import { User } from "@models/User";
import { convertIdInObject } from "@util/convert-id-field";
import apiClient from "./apiClient";

interface UserWithId extends Omit<User, "id"> {
    _id: string
}

export const signIn = async (
    email: string,
    password: string,
    captchaToken: string,
): Promise<User> => {
    try {
        const response = await apiClient.post<UserWithId>("/auth/login", {
            email, password, captchaToken,
        });
        return convertIdInObject(response.data);
    } catch (error) {
        console.error("Failed to sign in", error);
        throw error;
    }
};

export const refreshToken = async (): Promise<string> => {
    try {
        const response = await apiClient.post("/auth/refresh-token");
        return response.data.token;
    } catch (error) {
        console.error("Failed to refresh token", error);
        throw error;
    }
};

export const signOut = async (): Promise<void> => {
    try {
        const response = await apiClient.post("/auth/logout");
        return response.data;
    } catch (error) {
        console.error("Failed to sign out", error);
        throw error;
    }
};

export const resetPassword = async (email: string, captchaToken: string) => {
    try {
        const response = await apiClient.post("/auth/reset-password", { email, captchaToken, });
        return response.data;
    } catch (error) {
        console.error("Failed to reset password", error);
        throw error;
    }
};

export const setNewPassword = async (userId: string, token: string, password: string) => {
    try {
        const response = await apiClient.post("/auth/set-new-password", { userId, token, password });
        return response.data;
    } catch (error) {
        console.error("Failed to set new password", error);
        throw error;
    }
};
